// We don't need pkg here because it should be attached in the interceptor
export interface AladdinWealthServerGlobalParams {}

export const ALADDIN_WEALTH_SERVER_API_URL = process.env?.AWAPI_ALADDINWEALTHSERVER_URL || '/aladdinwealth';
export const ALADDIN_WEALTH_SERVER_API_URL_AGRAPH =
  process.env?.AWAPI_ALADDINWEALTHSERVER_URL_AGRAPH || '/api/wealth/legacy/aw-server/v1';
